import React from 'react'
import { Team } from 'src/components/AdminPanel/Team'

const TeamPage: React.FC = () => <Team />

export default TeamPage
